import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Import Pages
import Home from './pages/Home'
import LogIn from './pages/LogIn'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path='/login' component={LogIn} />
        <Route path='/' component={Home} />
      </Switch>
    </Router>
  )
}

export default App;